import { useCheckoutContext } from '../context/experienceCheckoutContext';

// Re-export the hook from the context file
export default useCheckoutContext; 